import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Subscription } from 'rxjs';
import { slideDown } from '../../shared/animations'

@Component({
    selector: 'busy-indicator',
    template: require('./busy-indicator.component.html'),
    styles: [require('./busy-indicator.component.scss')],
    animations: [slideDown]
})

export class BusyIndicatorComponent {
    @Input() busy: Subscription;
    @Input() message = 'Please wait...';
    @Input() withCancel = true;
    @Output() cancel = new EventEmitter();
    constructor() {}
}
